<template>
    <div style="padding-top: 35px">
        <div class="d-block row">
            <div class="col-lg-12">
                <div class="row" style="margin-top: -48px !important; margin-bottom: 10px !important">
                     <b-tabs :class="{ 'offset-lg-3': ShowFilter }" class="inside-tab" v-model="OutsideIndex" @input="tabChange()">
                      <b-tab title="Requests"> </b-tab>
                    </b-tabs>
                </div>
                <div class="row">
                    <div class="col-md-3" v-if="ShowFilter">
                        <div>
                            <div class="form-group filterSection col-md-12">
                                <label class="basic-class">Report Run as of Date</label>
                                <b-form-datepicker inputType="date" id="calendar-picker"
                                    :date-format-options="{ month: 'numeric', day: 'numeric' ,year: 'numeric'}"
                                    :max="new Date()" v-model="FilterList.DateTime">
                                </b-form-datepicker>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="basic-class">Form/Module</label>
                                <OmniSelect v-model="FilterList.Permission" :options="PermissionList" name="" :showLabel="false" placeholder="Form/Module" :showSearch="false" />
                            </div>
                            <div class="form-group col-md-12">
                                <label class="basic-class">Agency</label>
                                <OmniSelect v-model="FilterList.Agency" :options="AgencyList" name="" :showLabel="false" placeholder="Agency" :showSearch="false" />
                            </div>
                            <div class="form-group col-md-12">
                                <label class="basic-class">Security Role</label>
                                <OmniSelect v-model="FilterList.Role" :options="RoleList" name="" :showLabel="false" placeholder="Security Role" :showSearch="false" />
                            </div>
                            <div class="form-group col-md-12">
                                <label class="basic-class">User Name</label>
                                <input type="text" class="form-control" v-model="FilterList.User" placeholder="User Name" />
                            </div>
                            <div class="form-group col-md-12">
                                <label class="basic-class">Date Added/Date Modified</label>
                                <date-range-picker style="min-width: 98%" ref="picker" opens="right" :ranges="false" v-model="FilterList.CompletionDate" placeholder="Date Added/Date Modified" :locale-data="locale"
                                    :max-date ="maxDateFilter">
                                    <template v-slot:input="picker">
                                        <span v-if="IsValidDate(picker)">
                                            {{ picker.startDate | formatDate }} -
                                            {{ picker.endDate | formatDate }}</span>
                                        <span v-else class="placeholder">
                                            Filter by Completion Date
                                        </span>
                                    </template>
                                </date-range-picker>
                            </div>
                            <div class="row text-right">
                                <div class="col-md-11 p-0">
                                    <button class="btn btn-primary text-uppercase" v-on:click="RestValues()">
                                        RESET
                                    </button>
                                    <button class="btn btn-primary text-uppercase" v-on:click="FilterQuery()">
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="[{ 'col-md-12 ': !ShowFilter, 'col-md-9': ShowFilter },]">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <button class="text-left p-0 m-0 btn btn-link text-uppercase Open-Filter" @click="openfilter()" v-show="!ShowFilter">
                                            <b-img width="11" height="9" :src="openFilterIcon" /> Open Filter
                                        </button>
                                        <button v-show="ShowFilter" class="text-left p-0 m-0 btn btn-link text-uppercase Close-Filter" @click="closefilter()">
                                            <b-img width="11" height="9" :src="closeFilterIcon" /> Close Filter
                                        </button>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <b-button class="btn custom-button"  text="Download" variant="outline-primary" ref="popoverButton">
                                            Download
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                     <div class="row mb-2">
                        <b-popover placement="bottom" display="block" :target="$refs.popoverButton" :show.sync="show" variant="primary">
                            <div class="text-center  p-2">
                                <div class="container">
                                    <p class="popoverhover" @click="DownloadList('Excel');show = !show">
                                        EXCEL
                                    </p>
                                </div>
                                <div class="container">
                                    <p class="popoverhover m-0" @click="DownloadList('Pdf');show = !show">
                                        PDF
                                    </p>
                                </div>
                            </div>
                        </b-popover>

                     </div>
                        <b-table id="all-items" :per-page="perPage" :items="data.rows" :fields="fields" :no-local-sorting="true" @sort-changed="sortChange" show-empty striped hover responsive class="all-items">
                            <template v-slot:cell(Permission)="data">
                                <div class="text-center">
                                    {{ data.value | formatPermission }}
                                </div>
                            </template>
                            <template v-slot:cell(CreatedDate)="data">
                                <div class="text-center">
                                    {{ data.value | formatDate }}
                                </div>
                            </template>
                            <template v-slot:cell(UpdatedDate)="data">
                                <div class="text-center">
                                    {{ data.value | formatDate }}
                                </div>
                            </template>
                            <template slot="custom-foot" v-if="IsPaginationRequired">
                                <b-tr>
                                    <b-td class="custom-pagination" colspan="13">
                                        <b-form-select class="records-per-page" v-model="perPage" :options="RecordsPerPageOption"></b-form-select>
                                        <Pagination style="float: right" :per-page="perPage" aria-controls="open-items" v-model="currentPage" :total-rows="TotalRows" first-number last-number />
                                    </b-td>
                                </b-tr>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>

    <script>
    const moment = require("moment");
    import DateRangePicker from "vue2-daterange-picker";
    import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
    import {UpdateRecordsPerPageOption} from "./../utilities/paginationUtils";
    export default {
        components: {
            DateRangePicker,
        },
        name: "UserRoles",
        data() {
            return {
                RecordsPerPageOption:[],
                AgencyList: [],
                RoleList:[],
                PermissionList: [],
                locale: {
                    applyLabel: "Set",
                    cancelLabel: "Cancel",
                },
                
                OutsideIndex: 0,
                TotalRows: 0,
                closeFilterIcon: require("@/assets/Icons/close-filter-icon.svg"),
                openFilterIcon: require("@/assets/Icons/open-filter-icon.svg"),
                SearchData: null,
                sortBy: "CreatedDate",
                sortDesc: true,
                theme: "row",
                ShowFilter: false,
                getFixed: true,
                perPage: 10,
                currentPage: 1,
                fields: this.buildColumns(),
                data: {
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        pagination_info: true,
                        global_search: {
                            visibility: false,
                        },
                    },
                    loading: false,
                    classes: {
                        tableWrapper: "outer-table-div-class wrapper-class-two grid-table",
                        table: {
                            "table-sm": true,
                        },
                    },
                    rows: [],
                },
                FilterList: {
                    DateTime: this.getYesterdayDate(),
                    Agency: [],
                    Role: [],
                    Permission: [],
                    User: null,
                    CompletionDate: {
                        startDate: null,
                        endDate: null
                    },
                    Status: null,
                },
            };
        },
        created() {
            this.$store.commit("client/reset");
        },
        props: {
            index: {
                type: Number,
                required: true,
            },
        },
        mounted() {
            if (this.CanAccessList) {
                this.GetReport();
            } else {
                this.$router.push({
                    name: "unauthorized",
                    params: {
                        message: "UnAuthorized"
                    },
                });
            }
            this.$nextTick(function () {
                window.addEventListener("resize", this.getWindowWidth);
            });
        },
        watch: {
            currentPage: function (value) {
                if (value != null && parseInt(value) > 0) {
                    this.GetReport();
                }
            },
            perPage: function () {
                this.currentPage = 1;
                this.GetReport();
            },
            ShowFilter:function(value) {
                if(value == true) {
                    if(this.AgencyList == null||this.AgencyList.length == 0) {
                        this.LoadAgency();
                    }
                    if(this.RoleList == null||this.RoleList.length == 0) {
                        this.LoadAllRoles();
                    }
                    if(this.PermissionList == null||this.PermissionList.length == 0) {
                        this.LoadPermissions();
                    }
                }
           },
        },
        computed: {
            IsPaginationRequired() {
                return this.TotalRows != null && parseInt(this.TotalRows) > parseInt(this.perPage);
            },
            CanAccessList() {
                return this.$store.getters.canAccessList;
            },
            maxDateFilter(){
                return this.FilterList.DateTime != null ? this.FilterList.DateTime : this.getYesterdayDate();
            }
        },
        filters: {
            formatDate(date) {
                return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : "-";
            },
            formatDateAndTime(date) {
                return moment(date).isValid() ? moment(date).format("MM/DD/YYYY h:mma") : "-";
            },
            formatPermission(permission) {
                if (permission) {
                    if (permission.includes("_")) {
                        const [prefix, suffix] = permission.split("_");
                        permission = `${suffix.replace(/-/g, ' ')} / ${prefix.replace(/-/g, ' ')}`;
                    }
                    return permission.replace(/\w+/g, function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();});
                }
                return "-";
            },
        },
        methods: {
            getYesterdayDate() {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toISOString().split('T')[0];
            },
            tabChange() {
                this.fields = this.buildColumns();
            },
            IsValidDate(completionDate) {
                return (
                    completionDate != null &&
                    moment(completionDate.startDate).isValid() &&
                    moment(completionDate.endDate).isValid()
                );
            },
            onFiltered(e) {
                if ((e != null && e.length > 2) || e == null || e.length == 0) {
                    this.currentPage = 1;
                    this.GetReport();
                }
            },
            sortChange(e) {
                this.sortBy = e.sortBy;
                this.sortDesc = e.sortDesc;
                this.GetReport();
            },
            GetGridOptions() {
                let extrafilters = [];
                if (
                    this.FilterList.CompletionDate != null &&
                    this.FilterList.CompletionDate.hasOwnProperty("startDate") &&
                    this.FilterList.CompletionDate.startDate != null
                ) {
                    extrafilters.push({
                        Field: "CompletionDate",
                        Operator: "between",
                        Value: JSON.stringify(this.FilterList.CompletionDate),
                    });
                }

                if (this.FilterList.Agency != null && this.FilterList.Agency != "") {
                    extrafilters.push({
                        Field: "Agency",
                        Operator: "=",
                        Value: this.FilterList.Agency.join(","),
                    });
                }
                if (this.FilterList.Role != null && this.FilterList.Role != "") {
                    extrafilters.push({
                        Field: "Role",
                        Operator: "=",
                        Value: this.FilterList.Role.join(","),
                    });
                }
                if (this.FilterList.Permission != null && this.FilterList.Permission != "") {
                    extrafilters.push({
                        Field: "Permission",
                        Operator: "=",
                        Value: this.FilterList.Permission.join(","),
                    });
                }
                if (this.FilterList.User != null && this.FilterList.User != "") {
                    extrafilters.push({
                        Field: "User",
                        Operator: "contains",
                        Value: this.FilterList.User,
                    });
                }
                return {
                    PageSize: parseInt(this.perPage),
                    CurrentPageNumber: parseInt(this.currentPage),
                    FilterValue: this.SearchData,
                    SortBy: this.sortBy,
                    SortDesc: this.sortDesc,
                    Filters: extrafilters,
                    fileType: this.fileType
                };
            },
            buildColumns() {
                    let columns = [];

                    columns.push({
                        key: "Permission",
                        label: "Form/Module",
                    })
                    columns.push({
                        key: "Agency",
                        label: "Agency",
                    })
                    columns.push({
                        key: "Email",
                        label: "User",
                    })
                    columns.push({
                        key: "Role",
                        label: "Role",
                    })
                    columns.push({
                        key: "CreatedDate",
                        label: "Date Added",
                        // sortable: true,
                    })
                    columns.push({
                        key: "CreatedBy",
                        label: "Who Added",
                    })
                    columns.push({
                        key: "UpdatedDate",
                        label: "Date Modified",
                        // sortable: true,
                    })
                    columns.push({
                        key: "UpdatedBy",
                        label: "Who Modified",
                    })
                    return columns;
                },
            DownloadList(fileType) {
                this.fileType = fileType;
                let fileExtension = fileType === "Excel"? "xlsx" : "pdf"
                this.$store
                    .dispatch("usersRoles/DownloadList", this.GetGridOptions())
                    .then((response) => {
                        const type = response.headers["content-type"];
                        const blob = new Blob([response.data], {
                            type: type,
                            encoding: "UTF-8",
                        });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Requests_${moment().format("MMDDYYYYmmhhss")}.` + fileExtension;
                        link.click();
                        link.remove();
                    })
                    .catch((ex) => {
                        if (ex.response && ex.response.status == 503) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Starburst is down. Please try again later.`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching report.${ex}`
                        );
                    }
                });
            },
            GetReport() {
                this.TotalRows = 0;
                this.data.rows = [];
                this.$store
                .dispatch("usersRoles/GetProtegoUserRoleReport", this.GetGridOptions())
                .then((res) => {
                    if (res.data) {
                        this.TotalRows = res.data.Total;
                        this.data.rows = res.data.Result;
                        this.RecordsPerPageOption = UpdateRecordsPerPageOption(this.TotalRows);
                    }
                })
                .catch((ex) => {
                    if (ex.response && ex.response.status == 503) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching report.${ex}`
                        );
                    }
                });
            },
            async LoadAllRoles(){
                this.RoleList = [];
                this.$store
                .dispatch("usersRoles/GetAllRoles")
                .then((res) => {
                    if (res.data) {
                        res.data.forEach(element => {
                            this.RoleList.push(
                                {
                                    label: element.Role,
                                    value: element.Role,
                                }
                            )
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            async LoadAgency() {
                this.AgencyList = [];
                this.$store
                .dispatch("usersRoles/GetAllAgencies")
                    .then((res) => {
                    if (res.data) {
                        res.data.forEach(element => {
                            this.AgencyList.push(
                                {
                                    label: element.Agency,
                                    value: element.Agency,
                                }
                            )
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            async LoadPermissions() {
                this.PermissionList = [];
                this.$store
                .dispatch("usersRoles/GetAllPermissions")
                    .then((res) => {
                    if (res.data) {
                        res.data.forEach(element => {
                            let permissionLabel = this.$options.filters.formatPermission(element.Permission);
                            console.log(permissionLabel);
                            this.PermissionList.push(
                                {
                                    label: permissionLabel,
                                    value: element.Permission,
                                }
                            )
                        });
                        this.PermissionList = this.PermissionList.sort((a, b) =>
                            a.label < b.label ? -1 : a.label > b.label ? 1 : 0
                        );
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            FilterQuery: function () {
                this.currentPage = 1;
                this.GetReport();
            },

            OnChange: function (val) {
                alert(val);
            },

            select: function (val) {
                alert(val);
            },
            RestValues: function () {
                this.$set(this.FilterList.CompletionDate, "startDate", null);
                this.$set(this.FilterList.CompletionDate, "endDate", null);
                this.FilterList.Agency = [];
                this.FilterList.Role = [];
                this.FilterList.Permission = [];
                this.FilterList.User = null;
                this.FilterList.DateTime = this.getYesterdayDate();
                this.SearchData = null;
                this.GetReport();
            },
            closefilter() {
                this.theme = "row";
                this.ShowFilter = false;
            },
            openfilter() {
                (this.theme = "col-md-9"), (this.ShowFilter = true);
            },
            getWindowWidth: function () {
                this.getFixed = document.documentElement.clientWidth > 992 ? true : null;
            },
        },
    };
    </script>
<style>
.filterSection .b-calendar .b-calendar-inner {
    min-width: 250px;
    width: 100% !important;
}
.filterSection .b-calendar .b-calendar-grid-body .col[data-date] .btn {
    max-width: 35px !important;
    min-width: 35px !important;
    max-height: 35px !important;
    min-height: 35px !important;
    padding: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
}
.container:hover p {
    fill: #00a1d2 !important;
    color: #00a1d2 !important;
}
</style>